import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';

import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { Account } from '../../../../model/account';
import { ApiService } from '../../../../services/api';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
    selector: 'page-secretary-sheets-report-ipra',
    templateUrl: 'report-secretary-sheets-ipra.html'

})
export class SecretarySheetsReportIpra implements OnInit, OnDestroy {
    @Input('rodeo') rodeo: Rodeo;
    @Input('options') options: FormGroup;

    rodeoEvents: RodeoEvent[] = [];

    matchingMemberships: number[] = [];
    contestantFees: Map<number, number>;
    schedulesByDay: any[];

    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;
    imageOrganization:string = '';

    private subscriptions: Subscription[] = [];

    constructor(public api: ApiService, public dateHelper: DateHelperService) { }

    ngOnInit(): void {
        this.subscriptions.push(
            this.options.valueChanges.subscribe((e) => this.updateFromFormValues(e))
        );

        this.updateFromFormValues(this.options.value);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe());
    }

    updateFromFormValues(filters) {
        if (filters.rodeoEventId > 0) {
            this.rodeoEvents = this.rodeo.rodeoEvents.filter(x => x.id == filters.rodeoEventId);
        } else {
            const slack = !!filters.scheduleName && !!filters.scheduleName.toLowerCase().includes('slack');
            this.rodeoEvents = this.rodeo.rodeoEvents.filter(x => x.schedules && x.schedules.length > 0 && x.schedules.find(y => y.runs && y.runs.length > 0))
            .sort((a,b) => {
                if (a.eventOrders && b.eventOrders) {
                    return a.eventOrders.find(x => x.slack == slack).eventOrder - b.eventOrders.find(x => x.slack == slack).eventOrder;
                } else {
                    return a.id - b.id;
                }
            });;
        }

        this.load();
        
        console.log(this.contestantFees, this.schedulesByDay, this.matchingMemberships);
    }

    load() {
        this.contestantFees = new Map<number, number>();
        this.schedulesByDay = [];
        this.rodeo.organization.memberships.forEach(membership => {
            this.matchingMemberships.push(membership.id);
        });

        this.rodeo.sanctionedOrganizations.forEach(organization => {
            organization.memberships.forEach(membership => {
                this.matchingMemberships.push(membership.id);
            });
        });

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            this.schedulesByDay[rodeoEvent.id] = [];

            rodeoEvent.schedules.forEach((schedule) => {
                if (!this.schedulesByDay[rodeoEvent.id][new Date(this.dateHelper.formatDateToSelectedTimeZone(schedule.scheduledDate, this.rodeo.rodeoTimezone)).getDay()])
                    this.schedulesByDay[rodeoEvent.id][new Date(this.dateHelper.formatDateToSelectedTimeZone(schedule.scheduledDate, this.rodeo.rodeoTimezone)).getDay()] = [];

                this.schedulesByDay[rodeoEvent.id][new Date(this.dateHelper.formatDateToSelectedTimeZone(schedule.scheduledDate, this.rodeo.rodeoTimezone)).getDay()].push(...schedule.runs);
            });

            rodeoEvent.registrations.forEach((registration) => {
                if (!this.contestantFees.has(registration.contestantOneId))
                    this.contestantFees.set(registration.contestantOneId, this.rodeo.officeFee);

                var fee = registration.contestantTwo ? rodeoEvent.priceTiers[0].unitPrice / 2 : rodeoEvent.priceTiers[0].unitPrice;

                this.contestantFees.set(registration.contestantOneId, this.contestantFees.get(registration.contestantOneId) + fee);

                if (registration.contestantTwo) {
                    if (!this.contestantFees.has(registration.contestantTwoId))
                        this.contestantFees.set(registration.contestantTwoId, this.rodeo.officeFee);

                    this.contestantFees.set(registration.contestantTwoId, this.contestantFees.get(registration.contestantTwoId) + fee);
                }
            });
        });

        this.dataLoaded = true;
    }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    getMembershipIds(account: Account) {
        return [...new Set(account.memberships.filter(x => this.matchingMemberships.some(y => y == x.membership.id) && Date.parse(x.expiration) > Date.now()).map(x => x.id))];
    }

    getEntryFeeDue(rodeoEvent: RodeoEvent, rodeoEventRun: RodeoEventRun) {
        if (rodeoEventRun.contestantTwo == null) {
            return rodeoEvent.priceTiers[0].unitPrice;
        }

        return rodeoEvent.priceTiers[0].unitPrice / 2;
    }

    isMinor(account: Account) {
        return account.birthDate ? (new Date(Date.now() - +(new Date(account.birthDate))).getFullYear() - 1970) < 18 : false;
    }

    getOfficeFee() {
        return this.rodeo.officeFee;
    }

    getTotalRuns() {
        return this.rodeoEvents.flatMap(x => x.schedules).flatMap(x => x.runs).length;
    }

    getTotalClassRunsToday(rodeoEvent: RodeoEvent, schedule: RodeoEventSchedule) {
        return this.schedulesByDay[rodeoEvent.id][new Date(this.dateHelper.formatDateToSelectedTimeZone(schedule.scheduledDate, this.rodeo.rodeoTimezone)).getDay()].length;
    }

    getFinesDue(account: Account) {
        return 0.0;
    }

    getTotalDue(account: Account) {
        return this.contestantFees.has(account.id) ? this.contestantFees.get(account.id) : 0;
    }

    getRemainingDue(rodeoEvent: RodeoEvent, account: Account) {
        return this.getTotalDue(account);
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-secretary-sheets-ipra.ts